<template>
  <div class="adjust-table-wrapper">
    <p class="adjust-table-title">
      <span>{{layout.label}}:</span>
      <span @click="reset" v-if="canEdit">重置预算金额</span>
    </p>
    <a-table ref="adjustTable" class="adjust-table adjust-table-normal" :rowKey="record=>record.key" :columns="columns" :pagination="false" :defaultExpandAllRows="true" :dataSource="dataSource" :scroll="{x:scrollX,y:scrollY}">
      <template slot="budgetSubjectName" slot-scope="text, record, index">
        <div>
          <a-input class="edit-input" v-if="record.isAdd" v-model="record.budget_subject_name" @blur="setObjname"></a-input>
          <!-- <a-select class="adjust-table-select" v-if="record.isAdd" :allowClear="true" placeholder="请选择预算科目" showSearch :filterOption="selectFilterOption" v-model="record.budget_subject_id">
            <a-select-option :value="option.id" v-for="(option,index) in record.subjectOpts" :key="index">{{option.name}}</a-select-option>
          </a-select> -->
          <p v-else>{{text}}</p>
        </div>
      </template>
      <template v-for="col in editColumns" :slot="col.dataIndex" slot-scope="text, record, index" v-if="record.level===2">
        <div :key="col.dataIndex" class="editCol">
          <p v-if="!canEdit">{{record[col.dataIndex].changed_money}}</p>
          <p v-else class="edit-p">
            <a-input-number class="edit-input" :style="col.monthNum===moment().add(-1,'month').month() || col.monthNum===moment().month()?'padding-right:110px;':''" :min='0' :formatter="limitDecimals" :parser="limitDecimals" v-model="record[col.dataIndex].changed_money" :disabled="col.monthNum<moment().month()" @change="e=>count(e,record,col)" />
            <span class="frozen" v-if="col.monthNum===moment().add(-1,'month').month() || col.monthNum===moment().month()">| 已产生:{{record[col.dataIndex].frozen_money?record[col.dataIndex].frozen_money:'0.00'}}</span>
          </p>
          <p class="tip" :class="moneyToNumValue(record[col.dataIndex].diffMoney)>0?'add':'minus'" v-if="record[col.dataIndex].diffMoney && record[col.dataIndex].diffMoney!=='0.00'">
            <span v-if="!record[col.dataIndex].frozen_money || Number(record[col.dataIndex].changed_money)>=moneyToNumValue(record[col.dataIndex].frozen_money) || col.monthNum>moment().month()">{{record[col.dataIndex].diffMoney}}</span>
            <span v-else style="color:#ff4d07">不得小于已产生金额</span>
          </p>
        </div>
      </template>
      <template slot="total" slot-scope="text, record, index">
        <div>
          <p style="line-height:20px;font-size: 12px;color: rgba(0,0,0,0.65);">{{record.totalStr}}</p>
          <p class="tip" style="font-size: 12px;" v-if="record.diffMoneyTotal" :class="record.diffMoneyTotal>0?'add':'minus'">{{record.diffMoneyTotalStr}}</p>
        </div>
      </template>
      <template slot="edit" slot-scope="text, record, index">
        <span v-if="record.can_add || record.isAdd" style="font-size: 12px;color: #108EE9;cursor:pointer;margin-right:10px;" @click="addSubject(record)">新增科目</span>
        <span v-if="(record.isAdd || record.can_be_deleted) && record.level===2" style="font-size: 12px;color: #108EE9;cursor:pointer" @click="deleteSubject(record)">删除</span>
      </template>
    </a-table>
    <a-table v-if="footerDataSource.length>0 && footerDataSource[0].detail && footerDataSource[0].detail.length>0" ref="adjustTableFooter" class="adjust-table adjust-table-footer" :rowKey="record=>record.key" :columns="columns" :pagination="false" :dataSource="footerDataSource" :scroll="{x:scrollX}">
      <template v-for="col in editColumns" :slot="col.dataIndex" slot-scope="text, record, index" v-if="record.key==='footer'">
        <div :key="col.dataIndex" class="editCol">
          <p>{{record[col.dataIndex].changed_money}}</p>
          <p class="tip" :class="moneyToNumValue(record[col.dataIndex].diffMoney)>0?'add':'minus'" v-if="record[col.dataIndex].diffMoney && record[col.dataIndex].diffMoney!=='0.00'">{{record[col.dataIndex].diffMoney}}
          </p>
        </div>
      </template>
      <template slot="total" slot-scope="text, record, index">
        <div>
          <p style="line-height:20px;font-size: 12px;color: rgba(0,0,0,0.65);">{{record.totalStr}}</p>
          <p class="tip" style="font-size: 12px;" v-if="record.diffMoneyTotal" :class="record.diffMoneyTotal>0?'add':'minus'">{{record.diffMoneyTotalStr}}</p>
        </div>
      </template>
    </a-table>
    <a-divider v-if="quarterBudgetInfo.some(item=>{return item.isChanged})" />
    <a-row v-for="item in quarterBudgetInfo" :key="item.quarter" v-if="quarterBudgetInfo.some(item=>{return item.isChanged}) && item.quarter!=='all'">
      <a-col :xs="6" :sm="4" style="text-align: right; margin-bottom: 16px;">变更后Q{{item.quarter==='all'?'年度总':item.quarter}}预算(元)：</a-col>
      <a-col :xs="24" :sm="10" class="quarter-diff-wrapper">
        <span style="font-weight:bold">{{item.total_money}}</span>
        <span class="quarter-diff" :class="moneyToNumValue(item.total_diff_money)<0?'minus':''">（{{item.total_diff_money}}）</span>
      </a-col>
    </a-row>
    <a-row style="margin-top: 16px;" v-for="item in quarterBudgetInfo" :key="item.quarter" v-if="item.quarter==='all'">
      <a-col :xs="6" :sm="4" style="text-align: right;">变更后年度总预算(元)：</a-col>
      <a-col :xs="24" :sm="10" class="quarter-diff-wrapper">
        <span style="font-weight:bold">{{item.total_money}}</span>
        <span class="quarter-diff" :class="moneyToNumValue(item.total_diff_money)<0?'minus':''">（{{item.total_diff_money}}）</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';
import UUID from 'uuidjs';
import {
  getSubjectOptions,
  numToMoneyStr,
} from '../services/BudgetChangeService.js';
import { adaptiveTableScrollY } from '../utils/tools.js';

export default {
  components: {},
  props: {
    columns: Array,
    editColumns: Array,
    param: Array,
    layout: Object,
    canEdit: Boolean,
  },
  data() {
    return {
      dataSource: [],
      quarterBudgetInfo: [],
      scrollX: 0,
      scrollY: 700,
      limitDecimals: value => {
        const reg = /^(\-)*(\d+)\.(\d\d).*$/;
        if (typeof value === 'string') {
          return !isNaN(Number(value))
            ? value.replace(reg, '$1$2.$3')
            : value.substr(0, value.length - 1);
        } else if (typeof value === 'number') {
          return !isNaN(value)
            ? String(value).replace(reg, '$1$2.$3')
            : String(value).substr(0, value.length - 1);
        } else {
          return '';
        }
      },
    };
  },

  created() {
    this.scrollX = 0;
    this.columns.forEach(item => {
      this.scrollX = this.scrollX + item.width;
    });
    this.dataSource = _.cloneDeep(this.param);
    this.getQuarterBudgetInfo();
    adaptiveTableScrollY(this, 250);
  },
  mounted() {
    if (this.$refs.adjustTableFooter) {
      let dom = this.$refs.adjustTable.$el.querySelectorAll(
        '.ant-table-body',
      )[0];
      dom.addEventListener(
        'scroll',
        () => {
          this.$refs.adjustTableFooter.$el.querySelectorAll(
            '.ant-table-body',
          )[0].scrollLeft =
            dom.scrollLeft;
        },
        true,
      );
      let dom2 = this.$refs.adjustTableFooter.$el.querySelectorAll(
        '.ant-table-body',
      )[0];
      dom2.addEventListener(
        'scroll',
        () => {
          this.$refs.adjustTable.$el.querySelectorAll(
            '.ant-table-body',
          )[0].scrollLeft =
            dom2.scrollLeft;
        },
        true,
      );
    }
  },
  computed: {
    footerDataSource() {
      const dataSource = _.cloneDeep(this.dataSource);
      return [dataSource[dataSource.length - 1]];
    },
  },

  methods: {
    moment,
    UUID: UUID.generate,
    count(e, record, col) {
      let currentDetailCell = record.detail.find(
        item => item.month === col.month,
      );
      record[col.dataIndex].changed_money = Number(e);
      currentDetailCell.changed_money = e;
      currentDetailCell.diffMoney = Number(e) - currentDetailCell.total_money;
      this.$emit('update-data', {
        field: this.layout.field,
        data: this.dataSource,
      });
    },
    setObjname() {
      this.$emit('update-data', {
        field: this.layout.field,
        data: this.dataSource,
      });
    },
    addSubject(record) {
      this.setNewSubject(record);
      this.$emit('update-data', {
        field: this.layout.field,
        data: this.dataSource,
      });
    },
    setNewSubject(record) {
      const parentIndex =
        record.level === 1 ? record.index : record.parentIndex;
      let obj = {
        isAdd: true,
        parentIndex: parentIndex,
        key: this.UUID(),
        level: 2,
        budget_subject_name: '',
        detail: [],
        subjectOpts: [],
      };
      for (let i = 1; i <= 12; i++) {
        obj.detail.push({
          total_money: '0.00',
          frozen_money: undefined,
          month: moment()
            .month(i - 1)
            .format('YYYY-MM'),
          team_budget_detail_id: 0,
        });
        obj[`month${i}`] = {
          changed_money: '0.00',
        };
      }
      if (record.level === 1) {
        this.dataSource[parentIndex].children.push(obj);
        this.dataSource[parentIndex].children.forEach((item, index) => {
          item.selfIndex = index;
        });
      } else {
        this.dataSource[parentIndex].children.splice(
          record.selfIndex + 1,
          0,
          obj,
        );
        this.dataSource[parentIndex].children.forEach((item, index) => {
          item.selfIndex = index;
        });
      }
    },
    deleteSubject(record) {
      this.dataSource[record.parentIndex].children.splice(record.selfIndex, 1);
      this.dataSource[record.parentIndex].children.forEach((item, index) => {
        item.selfIndex = index;
      });
      this.$emit('update-data', {
        field: this.layout.field,
        data: this.dataSource,
      });
    },
    getQuarterBudgetInfo() {
      const totalInfo = this.dataSource.find(item => item.key === 'footer');
      if (totalInfo) {
        let quarterBudgetInfo = [];
        let total_money = 0;
        let total_diff_money = 0;
        let year_total_money = 0;
        let year_total_diff_money = 0;
        let quarter = 0;
        totalInfo.detail.forEach((item, index) => {
          year_total_money = year_total_money + Number(item.changed_money);
          year_total_diff_money =
            year_total_diff_money + Number(item.diffMoney);
          if (index % 3 === 0) {
            total_money = Number(item.changed_money);
            total_diff_money = Number(item.diffMoney);
            quarter = quarter + 1;
          } else {
            total_money = Number(item.changed_money) + total_money;
            total_diff_money = Number(item.diffMoney) + total_diff_money;
            if (index % 3 === 2) {
              quarterBudgetInfo.push({
                quarter: quarter,
                total_money: numToMoneyStr(total_money),
                total_diff_money:
                  total_diff_money > 0
                    ? `+${numToMoneyStr(total_diff_money)}`
                    : numToMoneyStr(total_diff_money),
                isChanged:
                  numToMoneyStr(total_diff_money) === '0.00' ? false : true,
              });
            }
          }
        });
        quarterBudgetInfo.push({
          quarter: 'all',
          total_money: numToMoneyStr(year_total_money),
          total_diff_money:
            year_total_diff_money > 0
              ? `+${numToMoneyStr(year_total_diff_money)}`
              : numToMoneyStr(year_total_diff_money),
          isChanged:
            numToMoneyStr(year_total_diff_money) === '0.00' ? false : true,
        });
        this.quarterBudgetInfo = [];
        quarterBudgetInfo.forEach((item, index) => {
          this.$set(this.quarterBudgetInfo, index, item);
        });
        // this.quarterBudgetInfo = quarterBudgetInfo;
      }
    },
    selectFilterOption(input, option) {
      return option.componentOptions.children[0].text.includes(input);
    },

    moneyToNumValue(val) {
      if (typeof val === 'number') {
        return val;
      } else {
        var num = val.trim();
        var ss = num.toString();
        if (ss.length == 0) {
          return '0';
        }
        return ss.replace(/,/g, '');
      }
    },

    reset() {
      this.$emit('reset');
    },
  },
  watch: {
    param: {
      handler(val) {
        this.dataSource = val;
        this.getQuarterBudgetInfo();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.adjust-table-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 22px;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;
  span:last-child {
    color: rgb(2, 149, 238);
    cursor: pointer;
  }
}
.adjust-table {
  .ant-table-fixed-right .ant-table-body-inner {
    overflow-y: scroll !important;
  }
  .ant-table-tbody > tr {
    height: 63px;
  }
  .ant-table-tbody > tr.ant-table-row-level-0 {
    height: 40px;
  }
  .ant-table-row {
    .ant-input,
    .ant-input-number {
      height: 26px;
    }
    .ant-input-number-input {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
    }
    .ant-input-number.ant-input-number-disabled {
      background: #f5f5f5;
      .ant-input-number-input {
        color: rgba(0, 0, 0, 0.45) !important;
      }
    }
    .ant-select-selection__rendered {
      height: 24px;
      line-height: 24px;
      font-size: 12px;
    }
    .ant-select-selection {
      height: 26px;
      width: 140px;
    }
  }

  .tip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 20px;
  }
  .tip.add {
    color: #ff4d07;
  }
  .tip.minus {
    color: #2dbe60;
  }
  .tip.add:before {
    content: '+';
  }
  .editCol {
    .edit-p {
      position: relative;
      width: 100%;
      .edit-input {
        width: 100%;
        .ant-input-number-handler-wrap {
          display: none;
        }
      }
      span.frozen {
        position: absolute;
        display: block;
        width: 110px;
        height: 26px;
        line-height: 26px;
        text-align: right;
        top: 0;
        right: 10px;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}
.adjust-table-normal {
  .ant-table-tbody > tr:last-child {
    display: none; //隐藏最后一行合计
  }
}
.adjust-table-footer {
  margin-top: -1px;
  .ant-table-thead {
    display: none;
  }
  .ant-table-tbody > tr {
    .tip {
      height: 20px;
    }
  }
  .ant-table-tbody > tr > td {
    border-top: 1px solid #e8e8e8;
  }
  //隐藏滚动条
  .ant-table-scroll .ant-table-body::-webkit-scrollbar {
    display: none;
    // color: transparent;
  }
  .ant-table-scroll .ant-table-body {
    -ms-overflow-style: none !important;
  }
  .ant-table-scroll .ant-table-body {
    overflow: -moz-scrollbars-none;
  }
}
.quarter-diff.minus {
  color: #2dbe60;
}
.quarter-diff-wrapper {
  color: #ff4d07;
}
</style>
